import icons from '../../__generated__/icons/icons.svg';
import { cn } from '../../utils/css/cn';
import { IconName } from './iconName';

export interface IconProps {
	name: IconName;
	size?: string;
	className?: string;
}

/* if you have any questions about how to use it, look at the section about icons in the README.md#icons */

export const Icon = ({ name, size = '24', className = '', ...props }: IconProps) => {
	return (
		<svg width={size} height={size} className={cn('fill-current inline', className)} {...props}>
			<use href={`${icons}#${name}`} />
		</svg>
	);
};

export default Icon;
